import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import CheckBoxViewModel from '@/ViewModels/Controls/CheckBoxViewModel';

export default class PrincipalHistorizationSelectionItemViewModel extends ControlViewModel {

    /**
     * Der Name des Mandanten
     */
    public label: LabelViewModel;

    /**
     * Die CheckBox zur Selektierung des Mandanten
     */
    public checkbox: CheckBoxViewModel;

    /**
     * Das ViewModel für den PrincipalHistorizationSelectionItem
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);
        this.label = this.paramOrDefault(params.label, null);
        this.checkbox = this.paramOrDefault(params.checkbox, null);
    }
}

ComponentManager.setViewModel('PrincipalHistorizationSelectionItemViewModel', PrincipalHistorizationSelectionItemViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');